'use client';
import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { useMemo } from 'react';

const FullscreenLayoutContext = React.createContext({});
const FullscreenLayoutProvider = ({
  isCloseable,
  children,
  close
}) => {
  const context = useMemo(() => ({
    close,
    isCloseable
  }), [close, isCloseable]);
  return jsx(FullscreenLayoutContext.Provider, {
    value: context,
    children: children
  });
};

export { FullscreenLayoutContext, FullscreenLayoutProvider };
//# sourceMappingURL=FullscreenLayoutContext.js.map
